import { formatCentsToDisplay } from '@/lib/form-state/money'
import { MdCheckCircle } from 'react-icons/md'
import { costPerConsultation, OnboardingFormState } from '../onboarding-state'

interface Props {
    form: OnboardingFormState
}

/** Última etapa: o que o "Concluir" vai criar, em português de gente. */
export default function ReviewStep({ form }: Props) {
    const isDoctor = form.profile === 'INDIVIDUAL_DOCTOR'
    const consulted = form.specialties.filter(
        specialty => specialty.consults !== false
    )
    const cost = costPerConsultation(form.costs, form.monthlyConsultations)

    const lines: string[] = []

    if (isDoctor) {
        lines.push(
            `Seu cadastro de profissional (${form.doctor.name || 'sem nome'})`
        )
        if (form.doctor.address.city) {
            lines.push(
                `Local de atendimento: ${form.doctor.address.label || 'Consultório'} — ` +
                    `${form.doctor.address.city}/${form.doctor.address.state}`
            )
        }
        if (form.specialties.length > 0) {
            lines.push(
                `${form.specialties.length} especialidade(s): ` +
                    form.specialties.map(specialty => specialty.name).join(', ')
            )
        }
        if (consulted.length > 0) {
            lines.push(
                `${consulted.length} item(ns) de consulta no catálogo, com custo de ` +
                    `${formatCentsToDisplay(cost) || 'R$ 0,00'}`
            )
        }
        if (form.isSurgeon && form.surgeries.length > 0) {
            lines.push(
                `${form.surgeries.length} cirurgia(s) no catálogo de procedimentos`
            )
        }
    }

    lines.push(
        'Os exames mais pedidos, prontos para você solicitar no prontuário'
    )

    return (
        <div className="flex flex-col gap-5">
            <p className="text-base-content/70">
                Ao concluir, vamos preparar sua conta com:
            </p>

            <ul className="flex flex-col gap-3">
                {lines.map((line, index) => (
                    <li key={index} className="flex items-start gap-3">
                        <MdCheckCircle className="mt-0.5 text-xl text-secondary shrink-0" />
                        <span className="text-sm text-base-content">
                            {line}
                        </span>
                    </li>
                ))}
            </ul>

            <div className="alert alert-info text-sm">
                <span>
                    Os exames são criados em segundo plano e aparecem no
                    catálogo em instantes.
                </span>
            </div>
        </div>
    )
}
